export var SENTRY_RELEASE = "006f771b87cf459d8020d9bbe21f4e3f636874f2";
